'use client'
import useScreenWidth from '@/hooks/useScreenWidth'
import { useRouter } from 'next/navigation'
import React, { useState, useEffect, useContext } from 'react'
const Template05 = (props: any) => {
  const screenWidth = useScreenWidth()
  const router = useRouter()
  const Navigate = (link: string) => {
    router.push(link)
  }
  return (
    <>
      {props.data !== undefined && (
        <section className="single-banner-section">
          <div className="single-banner position-relative">
            {(() => {
              const item = props.data.section_items[0]
              const isDesktop = screenWidth > 768
              const xPos = isDesktop ? item.desk_btn_x_position : item.mob_btn_x_position
              const yPos = isDesktop ? item.desk_btn_y_position : item.mob_btn_y_position
              const theme = isDesktop ? item.desk_btn_theme : item.mob_btn_theme

              if (item.description !== '' && xPos !== null) {
                const className =
                  theme === 'white'
                    ? 'btn btn-outline-light'
                    : theme === 'black'
                      ? 'btn btn-outline-black'
                      : 'btn btn-custom'

                return (
                  <button
                    className={className}
                    style={{
                      position: 'absolute',
                      left: `${xPos}%`,
                      top: `${yPos}%`,
                      transform: 'translate(-50%, -50%)',
                      zIndex: 10
                    }}
                    onClick={() => Navigate(item.link)}
                  >
                    {item.description}
                  </button>
                )
              }

              return null
            })()}
            {props.data?.section_items?.[0]?.description ? (
              props.data.section_items[0].description !== '' ? (
                <img
                  className="w-100"
                  src={
                    screenWidth > 768
                      ? props.data.section_items[0].desktop_image
                      : props.data.section_items[0].mobile_image
                  }
                  alt="product"
                />
              ) : (
                <span
                  className="offer-banner-link"
                  style={{ cursor: 'pointer' }}
                  onClick={(e) => Navigate(props.data.section_items[0].link)}
                >
                  <img
                    className=""
                    src={
                      screenWidth > 768
                        ? props.data.section_items[0].desktop_image
                        : props.data.section_items[0].mobile_image
                    }
                    alt="product"
                  />
                </span>
              )
            ) : null}
          </div>
        </section>
      )}
    </>
  )
}

export default Template05
